export default __webpack_public_path__ + "static/media/alarm-clock.c7f71b00.svg";